import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Auth Components
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import TrainerRegister from './pages/Auth/TrainerRegister';
import CounselorRegister from './pages/Auth/CounselorRegister';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import VerifyOTP from './pages/Auth/VerifyOTP';
import ChangePassword from './pages/Auth/ChangePassword';

// Dashboard Components
import StudentDashboard from './pages/Dashboard/StudentDashboard';
import TrainerDashboard from './pages/Dashboard/TrainerDashboard';
import CounsellorDashboard from './pages/Dashboard/CounsellorDashboard';
import MyCourses from './pages/Dashboard/MyCourses';
import MySessions from './pages/Dashboard/MySessions';
import CourseManagement from './pages/Dashboard/CourseManagement';
import SessionManagement from './pages/Dashboard/SessionManagement';

// Other Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AuthRoute from './components/AuthRoute';

// Public Pages
import Home from './pages/Home/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Specialization from './pages/Specialization';
import Courses from './pages/Courses';

import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/specialization" element={<Specialization />} />
              <Route path="/courses" element={<Courses />} />

              {/* Auth Routes */}
              <Route element={<AuthRoute />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/register-trainer" element={<TrainerRegister />} />
                <Route path="/register-counselor" element={<CounselorRegister />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-otp" element={<VerifyOTP />} />
              </Route>

              {/* Protected Student Routes */}
              <Route element={<ProtectedRoute allowedRoles={['student']} />}>
                <Route path="/student-dashboard" element={<StudentDashboard />} />
                <Route path="/my-courses" element={<MyCourses />} />
                <Route path="/my-sessions" element={<MySessions />} />
              </Route>

              {/* Protected Trainer Routes */}
              <Route element={<ProtectedRoute allowedRoles={['trainer']} />}>
                <Route path="/trainer-dashboard" element={<TrainerDashboard />} />
                <Route path="/course-management" element={<CourseManagement />} />
              </Route>

              {/* Protected Counselor Routes */}
              <Route element={<ProtectedRoute allowedRoles={['counselor']} />}>
                <Route path="/counselor-dashboard" element={<CounsellorDashboard />} />
                <Route path="/session-management" element={<SessionManagement />} />
              </Route>

              {/* Protected Common Routes */}
              <Route element={<ProtectedRoute allowedRoles={['student', 'trainer', 'counselor']} />}>
                <Route path="/change-password" element={<ChangePassword />} />
              </Route>
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;